import React from 'react'

import { Icon } from '@factorialco/deprecated-design-system'

import * as styles from './index.vanilla.css'

export interface Props {
  iconName: React.ComponentProps<typeof Icon.Medium>['icon']
  ariaLabel: string
  onClick: () => void
}

const ToolbarButton = ({ iconName, ariaLabel, onClick }: Props) => {
  return (
    <button aria-label={ariaLabel} className={styles.pdfViewerButton} onClick={onClick}>
      <Icon.Medium icon={iconName} color="grey000White" />
    </button>
  )
}

export default ToolbarButton
